import { render } from "./TotpSetup.vue?vue&type=template&id=1716c5ee&scoped=true"
import script from "./TotpSetup.vue?vue&type=script&lang=js"
export * from "./TotpSetup.vue?vue&type=script&lang=js"

import "./TotpSetup.vue?vue&type=style&index=0&id=1716c5ee&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1716c5ee"]])

export default __exports__